var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inscan-overage-shipment"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Process Overage Shipment")]), _vm._v(" "), (!_vm.isallowoverageApprovalFlag) ? _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('label', [_vm._v("Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "Shipment",
      "id": "Shipment",
      "value": "shipment"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "shipment")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "shipment"
      }, _vm.clearID]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "Shipment"
    }
  }, [_vm._v("Shipment")]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.checkedTypeError))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 radio"
  }, [_c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "Bag",
      "id": "Bag",
      "value": "bag"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "bag")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "bag"
      }, _vm.clearID]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "Bag"
    }
  }, [_vm._v("Bag")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.showOverageDetails
    }
  }, [_vm._v("Show")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")]), _vm._v("  \n                  ")])], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitShipment.apply(null, arguments)
      }
    }
  }, [(_vm.checkedType == 'shipment') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    class: {
      'form-control1': true, 'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.todate ? new Date(_vm.todate).setDate(new Date(_vm.todate).getDate() - 180) : '',
      "not-after": (_vm.todate) ? _vm.todate : _vm.todaysDate,
      "name": "FromDate"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    class: {
      'form-control1': true, 'error': _vm.errors.has('todate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "todate",
      "not-before": _vm.fromdate,
      "not-after": (_vm.fromdate) ? _vm.calculateMaxToDate(_vm.fromdate) : _vm.todaysDate
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkedType == 'shipment') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID",
      "name": "ShippingID",
      "id": "ShippingID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon, _vm.isblock), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIDError))])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shipmentForColor))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.searchShipmentID
    }
  }, [_vm._v("Search")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.inscanShipment
    }
  }, [_vm._v("Inscan")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearID
    }
  }, [_vm._v("Clear")])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to Inscan this Overage Shipment?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.UpdateShipmentOverage, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.checkedType == 'shipment') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', {
    staticStyle: {
      "color": "#20a8d8",
      "font-size": "17px"
    }
  }, [_vm._v("Inscan only if you have shipment physically. Do not inscan for wrong overage.")])])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.OverageShipmentList.length > 0) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "count-group"
  }, [_c('label', [_vm._v("Total Count : " + _vm._s(_vm.totalRows))])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("OverageHubID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CreatedBy")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CreatedDate")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ViewShipmentDetails")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.OverageShipmentList), function(data, index) {
    return [_c('tr', {
      class: {
        opened: _vm.opened.includes(index)
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))]), _vm._v(" "), (data.status == 'WrongInscan') ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "color": "#A8A8A8"
      },
      attrs: {
        "title": "View Details"
      }
    })]) : _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "View Details"
      },
      on: {
        "click": function($event) {
          return _vm.getShipmentOverageList(data, index)
        }
      }
    })])]), _vm._v(" "), (_vm.opened.includes(index)) ? _c('tr', {
      attrs: {
        "id": 'Route' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 20
      }
    }, [_c('br'), _vm._v(" "), _c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('legend', {
      staticClass: "header1"
    }, [_vm._v("Shipment Details"), _c('i', {
      staticClass: "fa fa-close fa-lg mt-2",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Close List"
      },
      on: {
        "click": _vm.closeList
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important"
      }
    }, [_c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("ShipmentStatus")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("OctroiMRP")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("NetPayment")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("OverageLocation")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Submit")])])]), _vm._v(" "), _c('tbody', [(_vm.OverageShipmentDetailsList.length != 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.shipmentstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.octroimrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.netpayment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.hubitem.text))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.OverageShipmentDetailsList.reason),
        expression: "OverageShipmentDetailsList.reason"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "reason"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.OverageShipmentDetailsList, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBcapturedbyscanner"
      }
    }, [_vm._v("Wrong AWB captured be scanner")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBtypingerror"
      }
    }, [_vm._v("Wrong AWB typing error")])]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.OverageShipmentDetailsList.reasonError))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.InscanShipmentOverage(_vm.OverageShipmentDetailsList)
        }
      }
    }, [_vm._v("Save")])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.OverageShipmentDetailsList.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "12"
      }
    }, [_vm._v("No Shipment Details added")])])]) : _vm._e()])])])], 1)]) : _vm._e()]
  }), _vm._v(" "), (_vm.OverageShipmentList.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.OverageShipmentList.length >= 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.OverageBagList.length > 0) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("OverageLocation")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PreviousHubName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("DestinationHubName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.OverageBagList), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.hubitem.text))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.reason),
        expression: "data.reason"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "reason"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(data, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBcapturedbyscanner"
      }
    }, [_vm._v("Wrong AWB captured by scanner")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WrongAWBtypingerror"
      }
    }, [_vm._v("Wrong AWB typing error")])]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.reasonError))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.InscanBagOverage(data)
        }
      }
    }, [_vm._v("Save")])])], 1)])
  }), _vm._v(" "), ((_vm.OverageBagList && _vm.OverageBagList.length == 0) || _vm.OverageBagList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.OverageBagList.length > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)]) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e42a085","hasScoped":true}!./src/views/components/InscanOverageShortage/InscanOverageShipment/InscanOverageShipment.html
// module id = 1077
// module chunks = 2